// Current Lodge Actions

import { getCurrentResortDataFromLodges } from '../../../utilities/resortLocation';
import currentLodgeActionTypes from './currentLodge.types';

export const updateCurrentLodge = lodges => dispatch => {
  dispatch({
    type: currentLodgeActionTypes.UPDATE_CURRENT_LODGE,
    resortData: getCurrentResortDataFromLodges(lodges) || {}
  });
};
